import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { icons } from '../../../constants'
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import LtsInputText from '../../../components/lottus/lts-input-text'
import { getExtension } from '../../../utils'

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function RenomarAnexoModal(props) {
  const [nomeAnexo, setNomeAnexo] = useState('')

  useEffect(() => {
    resetValues()
  }, [props.visible])

  const onHide = () => {
    props.onHide()
  }

  const onConfirm = () => {
    const oldName = _.get(props, 'anexoToRename.filename', '')
    const extensao = getExtension(oldName)
    props.onConfirm({ nomeAnexo: `${nomeAnexo}.${extensao}`, anexoToRename: props.anexoToRename })
    onHide()
  }

  const resetValues = () => {
    setNomeAnexo('')
  }

  return (
    <Dialog
      header={_.get(props, 'messages.orcamento.label.renomear.anexo', 'Renomear Anexo')}
      visible={props.visible}
      style={{ width: '80vw' }}
      onHide={() => {
        onHide()
      }}
      baseZIndex={1000000}
      modal={true}
      closable={true}
    >
      <div style={{ marginTop: '20px' }} className="p-grid p-fluid">
        <div className="form-group p-col-12">
          <LtsInputText
            value={_.get(props, 'anexoToRename.filename', '')}
            name={'nomeAnexoAnterior'}
            label={_.get(props, 'messages.orcamento.label.renomear.nome.atual', 'Nome Atual')}
            disabled={true}
          />
        </div>
      </div>
      <div style={{ marginTop: '20px' }} className="p-grid p-fluid">
        <div className="form-group p-col-12">
          <LtsInputText
            value={nomeAnexo}
            name={'nomeAnexo'}
            label={_.get(props, 'messages.orcamento.label.renomear.novo.nome', 'Novo Nome')}
            onChange={(e) => setNomeAnexo(e)}
          />
        </div>
      </div>
      <div style={{ marginTop: '20px' }} className="p-grid form-group">
        <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
          <Button
            label={_.get(props, 'messages.orcamento.label.confirmar', 'Confirmar')}
            onClick={() => {
              onConfirm()
            }}
            icon={icons.CHECK_ICON}
            className="p-button-success"
          />
        </div>
      </div>
    </Dialog>
  )
}
